import PageTitleBlock from '@organisms/PageTitleBlock';
import {
  ProfilePageWrapper,
  ProfileContentWrapper,
  ProfileAvatarWrapper,
  ProfileInfoWrapper,
  ProfileInfoBlock,
  ProfileInputWrapper,
  ProfileEditInputWrapper,
  ProfileButtonsWrapper,
  AvatarEditButton,
} from '@pages/ProfilePage.styles';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import Input from '@atoms/Input';
import {Edit} from '@carbon/icons-react';
import {useEffect, useMemo, useState} from 'react';
import Button from '@atoms/Button';
import EditPasswordModal from '@organisms/modals/EditPasswordModal';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch, RootState} from '@store';
import {saveProfile} from '@store/slices/profile';
import {roles as selectRoles} from '@store/slices/users';

export const ProfilePage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const profile = useSelector((state: RootState) => state.profile.profile);
  const roles = useSelector(selectRoles);
  const [profileName, setProfileName] = useState('—');
  const [profileEmail] = useState('—');
  const [profilePassword] = useState('* * * * * * *');
  const [showPassModal, setShowPassModal] = useState(false);
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [avatarPreview, setAvatarPreview] = useState<string | null>(null);

  const roleName = useMemo(() => {
    const roleId = profile?.role_id;
    const found = roles?.find(r => r.id === roleId);
    return found?.name || '—';
  }, [roles, profile]);

  useEffect(() => {
    if (profile?.username) {
      setProfileName(profile.username);
    }
  }, [profile?.username]);

  useEffect(() => {
    return () => {
      if (avatarPreview) URL.revokeObjectURL(avatarPreview);
    };
  }, [avatarPreview]);

  return (
    <ProfilePageWrapper>
      <PageTitleBlock title="Профиль" />
      <ProfileContentWrapper>
        <ProfileInfoWrapper>
          <ProfileAvatarWrapper>
            {avatarPreview ? (
              <img src={avatarPreview} alt="avatar" width={128} height={128} />
            ) : profile?.avatar_url ? (
              <img src={profile.avatar_url} alt="avatar" width={128} height={128} />
            ) : (
              <div>
                <img
                  src={'/assets/user-no-avatar.svg'}
                  alt="avatar"
                  width={64}
                  height={64}
                />
              </div>
            )}
            <AvatarEditButton
              onClick={() => {
                const input = document.getElementById(
                  'avatar-upload-input',
                ) as HTMLInputElement;
                if (input) input.click();
              }}>
              <Edit size={14} fill={theme.colors.basic00} />
            </AvatarEditButton>
            <input
              id="avatar-upload-input"
              type="file"
              accept="image/*"
              style={{display: 'none'}}
              onChange={e => {
                const file = e.target.files?.[0] || null;
                setAvatarFile(file);
                if (file) {
                  const objectUrl = URL.createObjectURL(file);
                  setAvatarPreview(objectUrl);
                } else {
                  setAvatarPreview(null);
                }
              }}
            />
          </ProfileAvatarWrapper>
          <ProfileInfoBlock>
            <div>
              <Text text="Роль:" type="tinyR" color={theme.colors.basic02} />
              <Text text={roleName} type="bodyM" />
            </div>
            <div>
              <Text
                text="Последняя активность"
                type="tinyR"
                color={theme.colors.basic02}
              />
              <Text text="13:45, сегодня, 26 Апреля, 2025" type="bodyM" />
            </div>
          </ProfileInfoBlock>
        </ProfileInfoWrapper>
        <ProfileInputWrapper>
          <Input
            id="profile-name"
            label="Имя"
            value={profileName}
            onChange={e => {
              setProfileName(e.currentTarget.value);
            }}
            withoutErrorText
            width="334px"
          />
        </ProfileInputWrapper>
        <ProfileInputWrapper>
          <Input
            id="profile-email"
            label="ID / Email"
            value={profile?.email ?? profileEmail}
            onChange={e => {
              setProfileName(e.currentTarget.value);
            }}
            withoutErrorText
            width="334px"
            disabled
          />
          <ProfileEditInputWrapper onClick={() => {}}>
            <Edit size={16} fill={theme.colors.accent00} />
          </ProfileEditInputWrapper>
        </ProfileInputWrapper>
        <ProfileInputWrapper>
          <Input
            id="profile-password"
            label="Пароль"
            value={profilePassword}
            withoutErrorText
            width="334px"
            disabled
          />
          <ProfileEditInputWrapper
            onClick={() => {
              setShowPassModal(true);
            }}>
            <Edit size={16} fill={theme.colors.accent00} />
          </ProfileEditInputWrapper>
        </ProfileInputWrapper>
        <ProfileButtonsWrapper>
          <Button
            title="Сохранить изменения"
            onClick={() => {
              const payload: {
                username?: string;
                email?: string;
                avatarFile?: File | null;
              } = {};
              if (profileName && profileName !== profile?.username) {
                payload.username = profileName;
              }
              if (avatarFile) {
                payload.avatarFile = avatarFile;
              }
              if (Object.keys(payload).length === 0) return;
              dispatch(saveProfile(payload));
            }}
            size="big"
            variant="filled"
          />
        </ProfileButtonsWrapper>
      </ProfileContentWrapper>
      <EditPasswordModal
        isOpened={showPassModal}
        onCloseRequest={() => {
          setShowPassModal(false);
        }}
      />
    </ProfilePageWrapper>
  );
};

export default ProfilePage;
